export function resolveCookieDomainAttribute(hostname: string | null | undefined) {
  if (!hostname) {
    return '';
  }

  if (hostname === 'viralengineapp.com' || hostname.endsWith('.viralengineapp.com')) {
    return '; domain=.viralengineapp.com';
  }

  return '';
}
